import script from "./HrSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./HrSelect.vue?vue&type=script&setup=true&lang=js"

import "./HrSelect.vue?vue&type=style&index=0&id=5c5066c2&lang=scss&scoped=true"
import "./HrSelect.vue?vue&type=style&index=1&id=5c5066c2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c5066c2"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QField from 'quasar/src/components/field/QField.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QField,QMenu,QItem});
